import * as React from 'react';
import {useLocation} from 'react-router-dom';
import errorNotice from '../../assets/Error_notice.png';
import {useTranslation} from 'react-i18next';
import {
  MOBILE_ERROR_TYPE,
  MOBILE_ERROR_TYPE_TO_MESSAGE, PAYMENT_STATUS,
  POST_MESSAGE_CONTENT_MESSAGE, POST_MESSAGE_TYPE
} from '../../common/constants';
import styles from '../../css/SamsungPayMobileBox.module.css';
import classNames from 'classnames/bind';
import SamsungPayMobileBox from '../../components/common/SamsungPayMobileBox';
import {postMessageToParent} from '../../utils/postMessage';
import {useSelector} from 'react-redux';
import {useEffect} from 'react';

const cx = classNames.bind(styles);

export default function MobileErrorPage() {
  const {t} = useTranslation();
  const location = useLocation();
  const errorType = location.state?.errorType || MOBILE_ERROR_TYPE.OTHER_ERRORS;
  const {sourceOrigin} = useSelector((state) => state.paymentClient);

  useEffect(() => {
    window.history.replaceState(null, '', window.location.href);
    window.history.pushState(null, '', window.location.href);

    const preventGoBack = (event) => {
      event.preventDefault();
      postMessageToParent({
        type: POST_MESSAGE_TYPE.PAYMENT_RESULT,
        content: {
          status: PAYMENT_STATUS.FAIL,
          message: getContentMessage(errorType)
        },
        sourceOrigin: sourceOrigin
      });
    };

    window.addEventListener('popstate', preventGoBack);
    return () => {
      window.removeEventListener('popstate', preventGoBack);
    };
  }, [sourceOrigin]);

  const getContentMessage = (errorType) => {
    let contentMessage;

    switch (errorType) {
    case MOBILE_ERROR_TYPE.USER_CANCEL:
      contentMessage = POST_MESSAGE_CONTENT_MESSAGE.USER_CANCEL;
      break;
    case MOBILE_ERROR_TYPE.PAYMENT_TIMEOUT:
      contentMessage = POST_MESSAGE_CONTENT_MESSAGE.PAYMENT_TIMEOUT;
      break;
    case MOBILE_ERROR_TYPE.OTHER_ERRORS:
    default:
      contentMessage = POST_MESSAGE_CONTENT_MESSAGE.PAYMENT_ERROR;
    }

    return contentMessage;
  };

  const handleCloseButtonClick = () => {
    postMessageToParent({
      type: POST_MESSAGE_TYPE.PAYMENT_RESULT,
      content: {
        status: PAYMENT_STATUS.FAIL,
        message: getContentMessage(errorType)
      },
      sourceOrigin: sourceOrigin
    });
  };

  return (
    <SamsungPayMobileBox mobilePageType="status" closeButtonFunction={handleCloseButtonClick}>
      <div>
        <p className={cx('txt')}>
          <img src={errorNotice} className={cx('ico-error')} alt="error notice logo"/>
          {t(MOBILE_ERROR_TYPE_TO_MESSAGE[errorType])}
        </p>
      </div>
    </SamsungPayMobileBox>
  );
}